module.exports = __webpack_public_path__ + "img/Databricks.cf1bd5a5.png";